// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ITmcColumnCountByClass {
	columnKey: string | undefined;

	light: number;

	medium: number;

	heavy: number;

	$type?: string | undefined;
}
export class TmcColumnCountByClass {
	constructor(data?: ITmcColumnCountByClass) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	columnKey: string | undefined;

	light: number = 0;

	medium: number = 0;

	heavy: number = 0;

	static $type: string = "CoreApi.Models.Reports.TmcColumnCountByClass, ";
	$type?: string | undefined = TmcColumnCountByClass.$type;
}

